module.exports = __webpack_public_path__ + "f59f9dba87556aa13960519ab602ba50.png";